// 没有slug，只有id的情况下，打开official profile

import { fetchOfficialAccount } from '@/hooks';
import { openNewWindow } from './common';
import queryClient from './queryClient';
import { convertOfficialHiIdToOriginalId } from './user';
import { getOfficialPath } from './officialAccount';

export const openOfficialById = ({
  address,
  officialId,
}: {
  address?: string;
  officialId: string;
}) => {
  const originalId = convertOfficialHiIdToOriginalId(officialId); // 没有0x开头；
  const officialDetail: { official: OfficialAccount } | undefined = queryClient.getQueryData([
    '/official',
    originalId,
    address,
  ]);
  if (officialDetail?.official) {
    // 命中缓存
    openNewWindow(getOfficialPath(officialDetail?.official));
  } else {
    fetchOfficialAccount(originalId).then(res => {
      if (res?.official) {
        openNewWindow(getOfficialPath(res?.official));
      }
    });
  }
};
